import React, { forwardRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { motion } from 'framer-motion'
import { toast } from 'react-toastify'
import { Close } from '@mui/icons-material'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function WillSimple({
  addTrust = false,
  updateIntakeStateAndSubmit,
  updateIntakeStateAtKey,
  onClose,
}) {
  const handleCreateWillClose = () => {
    onClose()
  }
  const handleHaveWillClose = () => {
    updateIntakeStateAndSubmit(() => {
      const newState = updateIntakeStateAtKey({ hasWill: true })
      toast.info('You have successfully completed setting up a will', {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      })
      onClose()
      return newState
    })()
  }
  const handleHaveTrustClose = () => {
    updateIntakeStateAndSubmit(() => {
      const newState = updateIntakeStateAtKey({ hasTrust: true })
      toast.info('You have successfully completed setting up a trust', {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      })
      onClose()
      return newState
    })()
  }
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{ sx: { overflow: 'visible' } }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <Box
            sx={{
              justifyContent: 'space-between',
              position: 'relative',
              top: -64,
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 0,
                right: -16,
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box p={3}>
            <Box>
              <Typography variant="headerTitle" sx={{ color: '#262627' }}>
                Already Have a {addTrust ? 'Trust' : 'Will'} or Need Help
                Creating One?
              </Typography>
            </Box>
            <Typography variant="body1" mt={3}>
              Our partners at Trust & Will are experts in{' '}
              {addTrust ? 'trust' : 'will'} creation and are ready to help you
              get the process started. Use the button below to begin or let us
              know you already have a {addTrust ? 'trust' : 'will'}!
            </Typography>
            <Box display="flex" justifyContent="space-between" mt={3}>
              <Button
                rel="noreferrer"
                size="large"
                variant="contained"
                href="https://trustandwill.com/advisors/invite/ktviem01?utm_medium=affiliate&utm_source=impact&utm_campaign=2736293&utm_content=w-wSXa2fNxyKRY4xwczFPTbCUkCxjNxChVHT0o0&utm_name&utm_term&irgwc=1&ir_partnerid=2736293&ir_adid=1189778&ir_campaignid=11883"
                target="_blank"
                onClick={handleCreateWillClose}
                sx={{
                  padding: '8px 24px',
                  backgroundColor: '#2370ED',
                  border: '2px solid #2370ED',
                  color: '#fff',
                  boxShadow: 'none',
                  borderRadius: '100px',
                  textTransform: 'capitalize',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: 1.5,
                  '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                    transform: 'none',
                    backgroundColor: '#1c59bd',
                    borderColor: '#1c59bd',
                    boxShadow: 'none',
                  },
                  '&:disabled': {
                    borderColor: 'rgba(0,0,0,0)',
                  },
                }}
              >
                Create A {addTrust ? 'Trust' : 'Will'}
              </Button>
              <Button
                rel="noreferrer"
                size="large"
                variant="contained"
                onClick={addTrust ? handleHaveTrustClose : handleHaveWillClose}
                // onClick={updateIntakeStateAndSubmit(() =>
                //   updateIntakeStateAtKey({ hasWill: true })
                // )}
                sx={{
                  padding: '8px 24px',
                  backgroundColor: '#2370ED',
                  border: '2px solid #2370ED',
                  color: '#fff',
                  boxShadow: 'none',
                  borderRadius: '100px',
                  textTransform: 'capitalize',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: 1.5,
                  '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                    transform: 'none',
                    backgroundColor: '#1c59bd',
                    borderColor: '#1c59bd',
                    boxShadow: 'none',
                  },
                  '&:disabled': {
                    borderColor: 'rgba(0,0,0,0)',
                  },
                }}
              >
                I Have A {addTrust ? 'Trust' : 'Will'}
              </Button>
            </Box>
          </Box>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
